import axios from 'axios';
import axiosRetry from 'axios-retry';
import { standardRetryPolicy } from './axiosRetryPolicy';
export const createDocumentReference = (baseUrl, accessToken, documentUrl, productConfigUrl) => {
    const client = axios.create();
    const handlePrepressRetry = (response) => {
        var _a;
        switch (response.data.Status) {
            case 'Completed':
                if (!((_a = response.data.Output) === null || _a === void 0 ? void 0 : _a.DocumentReferenceUrl)) {
                    const error = new Error('We could not process your uploaded file. Please try again.');
                    error.name = 'An error has occurred.';
                    throw error;
                }
                return Promise.resolve(response.data.Output.DocumentReferenceUrl);
            case 'Creating':
                return new Promise(r => setTimeout(r, 1000))
                    .then(() => client.get(response.data.ResultUrl, {
                    baseURL: baseUrl,
                    headers: {
                        Authorization: (/\.cimpress\.io$/).test(new URL(response.data.ResultUrl).host) ? `Bearer ${accessToken}` : ''
                    }
                }))
                    .then(handlePrepressRetry);
            default:
                const error = new Error('We could not process your uploaded file. Please try again.');
                error.name = 'An error has occurred.';
                throw error;
        }
    };
    axiosRetry(client, standardRetryPolicy);
    const rotationType = undefined;
    const alternatePageRotation = undefined;
    const scaleMode = undefined;
    const docPrepInput = {
        FileUrls: [documentUrl],
        parameters: {
            Type: 'DocPrep.V2.Parameters',
            productConfigUrl: productConfigUrl,
            placementParameters: {
                rotationType: rotationType || 'Rotate270',
                alternatePageRotation: alternatePageRotation === undefined,
                scaleMode: scaleMode || 'StretchToFill'
            },
            allowPageNumberMismatch: true,
            filePrepParameters: {
                Type: 'FilePrep.V2.Parameters',
                skipChecks: true,
                convertImageToPdf: false
            }
        }
    };
    return client
        .post('/v2/doc-prep?asynchronous=true&priority=Highest&inline=true&noRedirect=true', docPrepInput, {
        baseURL: baseUrl,
        headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        }
    })
        .then(response => client.get(response.data.ResultUrl))
        .then(handlePrepressRetry)
        .catch(() => {
        const error = new Error('We are having trouble retrieving additional information about this item.');
        error.name = 'An error has occurred.';
        throw error;
    });
};
//# sourceMappingURL=prepress.js.map